module.exports = __webpack_public_path__ + "img/hr-grass-3.de3e4bad.png";